import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import AuthGuard from "@/components/AuthGuard";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import SignUp from "@/pages/SignUp";
import RegisterSchool from "@/pages/RegisterSchool";
import Marketplace from "@/pages/Marketplace";
import AssetDetail from "@/pages/AssetDetail";
import Profile from "@/pages/Profile";
import Dashboard from "@/pages/Dashboard";
import JoinClass from "@/pages/JoinClass";
import Collections from "@/pages/Collections";
import CollectionDetail from "@/pages/CollectionDetail";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/register-school" element={<RegisterSchool />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/asset/:id" element={<AssetDetail />} />
            <Route path="/profile/:userId" element={<Profile />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/collections/:id" element={<CollectionDetail />} />
            <Route path="/dashboard" element={<AuthGuard><Dashboard /></AuthGuard>} />
            <Route path="/dashboard/approvals" element={<AuthGuard><Dashboard /></AuthGuard>} />
            <Route path="/join/:joinCode" element={<AuthGuard><JoinClass /></AuthGuard>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" toastOptions={{ style: { background: "#0F0F0F", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
